export default {
  URLS: {
	DEPARTMENT: '/kiosk/departments/',
  },
};